import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';

declare var $: any;

@Component({
  selector: 'ngx-work-notes-recall',
  templateUrl: './notes-recall.component.html',
})
export class NotesRecallComponent implements OnInit {

  private _pet_no: number;
  recall = false;
  notes = true;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    // this.petService.getPetCheckIn(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('tab') === 'recall') {
      this.ver('recall');
    }

    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
          this.petService.getNotesByPetId(this.pet_no).then(() => { });
        }
      });
  }

  add() {
    $('#modalNewPetNote').modal('toggle')
  }

  edit(item) {
    this.petService.pet_note = item;
    $('#modalNewPetNote').modal('toggle')
  }

  ver(tipo: string) {
    this.recall = tipo === 'recall'
    this.notes = tipo === 'notes'
  }
}
